import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import {LatestFeedList} from 'modules/feed';

export default connect(
  createSelector(
    (state, props) => ({
      model: _.get(state, 'home.news.feed'),
      panel_row1_right: _.get(state, 'subject.panel_row1_right'),
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      mediaTypes: _.get(state, 'mediaType.mediaTypeById'),
      mediaTypeIds: _.get(state, 'mediaType.mediaTypeIds'),
      sourceGroup: _.get(state, 'sourceGroup.entities'),
    })
  ,
    (state) => {
      const {panel_row1_right, checkMediaType} = state;
      const subjectId = _.get(panel_row1_right, 'data[0]')
      const subject = state.subjects[subjectId] || {};
      const mediaTypes = _.keys(_.get(subject, 'queries'));
      const model = state.model;
      const renderMediaType = ['facebook', 'video']
      return {
        model,
        showAppend: true,
        query: {
          ...state.query,
          subjectId: subjectId,
          mediaType: _.head(mediaTypes),
          limit: 5,
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
        },
      };
    }
  ),
  () => ({})
)(LatestFeedList);



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/NewsFeedListContainer.js
 **/